import styled from 'styled-components';

export const Item = styled.div`
	border: 1px solid #e7e7e7;
	border-radius: 8px;
	padding: 16px;
`;

export const Content = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	div:first-child {
		display: flex;
		align-items: center;
		gap: 10px;
	}
`;

export const ButtonsContainer = styled.div`
	display: flex;
	justify-content: center;
	gap: 5px;
`;
